import React, { useState } from "react";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import Button from "@rio-cloud/rio-uikit/Button";
import ErrorDialog from "../../../../../../../components/dialogs/ErrorDialog";

interface ICreateServiceBayDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
}

const CreateServiceBayDialog = ({
  isOpen,
  onClose,
  onSave,
}: ICreateServiceBayDialogProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const [name, setName] = useState("");
  const [hasError, setHasError] = useState(false);

  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || name.trim() === "") {
      setHasError(true);
      return;
    }

    try {
      setIsLoading(true);
      await onSave(name);
      setHasError(false);
      onClose();
      setError(null);
    } catch (error: any) {
      setError(error.message || "Erro ao criar box");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    setHasError(false);
  };

  return (
    <>
      <Dialog show={isOpen} onClose={onClose} showCloseButton bsSize="md">
        <form onSubmit={handleSubmit}>
          <Dialog.Title title="Criar Box" />

          <Dialog.Body>
            <div className="form-group">
              <label htmlFor="boxName" className="text-size-14">
                Nome
              </label>
              <input
                id="boxName"
                name="boxName"
                className={`form-control h-[44px] ${
                  hasError ? "border border-danger" : ""
                }`}
                placeholder="Digite o nome do box"
                value={name}
                onChange={handleInputChange}
                required
                maxLength={20}
              />
              {hasError && (
                <p className="text-danger text-sm mt-1">
                  O nome é obrigatório.
                </p>
              )}
            </div>
          </Dialog.Body>

          <Dialog.Footer>
            <Button
              className={`btn btn-primary ${
                isLoading ? "btn-loading disabled" : ""
              }`}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Salvando..." : "Salvar"}
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog>

      <ErrorDialog
        show={!!error}
        title="Erro ao criar box"
        body={error}
        onClose={() => setError(null)}
      />
    </>
  );
};

export default CreateServiceBayDialog;
